import React, { useState } from 'react'

interface TaskNodeDetailProps {
  icon?: JSX.Element
  label: string
  value: string
  fields?: {
    label: string
    value: React.ReactNode
  }[]
}

export const TaskNodeDetail = ({ icon, label, value, fields }: TaskNodeDetailProps): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className="task-detail-container">
      <div className={`task-detail-body ${isOpen ? 'task-detail-body--expanded' : ''}`}>
        <div className="task-detail-body-icon">{icon}</div>
        <div className="task-detail-body-entries">
          <div className="task-detail-body-entry">
            <p>{label}</p>
            {isOpen ? null : <p>{value}</p>}
          </div>
          {fields?.map((field) => {
            return (
              <div key={`${label}-field-${field.label}`} className="task-detail-body-entry">
                <p>{field.label}</p>
                <p>{field.value}</p>
              </div>
            )
          })}
        </div>
      </div>
      {fields ? (
        <button className="task-detail-toggle" onClick={() => setIsOpen((open) => !open)}>
          <svg width={12} height={12} viewBox="-2 -2 14 14">
            <polyline
              points={isOpen ? '0,7.5 5,2.5 10,7.5' : '0,3.5 5,8.5 10,3.5'}
              fill="none"
              strokeWidth="2px"
              strokeLinecap="round"
            />
          </svg>
        </button>
      ) : null}
      <style jsx>{`
        .task-detail-container {
          width: 100%;
          margin-top: 12px;
          display: flex;
        }

        .task-detail-body {
          max-height: 18px;
          width: 255px;
          box-sizing: border-box;
          border-radius: 9px;
          overflow: hidden;
          display: flex;
          transition: 300ms;
          transition-timing-function: ease;
        }

        .task-detail-body--expanded {
          max-height: 150px;
        }

        .task-detail-body-icon {
          width: 18px;
          min-width: 18px;
          height: 18px;
          min-height: 18px;
          margin-right: 16px;
          border-radius: 9px;
          background: #badaf2;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .task-detail-body-entries {
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
        }

        .task-detail-body-entry {
          width: 100%;
          box-sizing: border-box;
          min-height: 18px;
          margin-bottom: 9px;
          font-family: 'Space Mono', monospace;
          font-size: 11px;
          line-height: 16px;
          padding-right: 9px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          overflow: hidden;
        }

        .task-detail-body-entry > p {
          margin: 0;
          white-space: nowrap;
        }

        .task-detail-body-entry:last-child {
          margin-bottom: 3px;
        }

        .task-detail-toggle {
          width: 18px;
          min-width: 18px;
          height: 18px;
          min-height: 18px;
          padding: 0;
          margin-left: 9px;
          border-radius: 18px;
          border: 2px solid #333;
          background: none;
          display: flex;
          justify-content: center;
          align-items: center;
          transition: 300ms;
          transition-timing-function: ease;
        }

        .task-detail-toggle:hover {
          cursor: pointer;
          border: 2px solid #333;
        }

        .task-detail-toggle > svg > polyline {
          stroke: #333;
          transition: 300ms;
          transition-timing-function: ease;
        }

        .task-detail-toggle:hover > svg > polyline {
          stroke: #333;
        }
      `}</style>
    </div>
  )
}
